module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6dac3a9bb6825037e30afb338ad08a64.png";